module.exports = __webpack_public_path__ + "static/media/DecVirtualCard@2x.guaranteed-rate.0de79319.png";